import { CustomReportSchema } from "@redotech/redo-model/custom-report";
import { z } from "zod";

export const getCustomReport = {
  input: z.object({
    customReportId: z.string(),
  }),
  output: z.object({
    customReport: CustomReportSchema.nullable(),
  }),
};

export const getCustomReports = {
  input: z.object({}),
  output: z.object({
    customReports: z.array(CustomReportSchema),
  }),
};

export const createCustomReport = {
  input: z.object({
    name: z.string(),
    queryParams: z.map(z.string(), z.string()), // TODO verify
    // TODO @JstnMcBrd email settings
  }),
  output: z.object({
    customReport: CustomReportSchema,
  }),
};

export const updateCustomReport = {
  input: z.object({
    customReportId: z.string(),
    name: z.string(),
    // TODO @JstnMcBrd email settings
  }),
  output: z.object({
    customReport: CustomReportSchema,
  }),
};

export const deleteCustomReport = {
  input: z.object({
    customReportId: z.string(),
  }),
  output: z.object({}),
};
